import { ContentLayout } from '@/components/Layout/Admin/ContentLayout'
import React, { useState } from 'react'
import { Logo } from '@/components/Layout/Public/Navbar'
import InputField from '../components/InputField'
import { NavLink } from 'react-router-dom'

function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handelChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target

    switch (name) {
      case 'email':
        setEmail(value)
        break
      case 'password':
        setPassword(value)
        break
    }
  }

  const handelSubmit = () => {}

  return (
    <ContentLayout title="login">
      <div className=" flex size-full min-h-svh flex-col items-center justify-center gap-7 ">
        <div className="text-center">
          {Logo}{' '}
          <h1 className=" text-2xl font-bold text-[rgba(51,51,51,1)] md:text-3xl md:leading-[3.6rem] ">
            Log in to your account
          </h1>
        </div>

        <div className=" w-full max-w-[350px] shadow-md md:max-w-[448px] ">
          <form
            action=""
            className="flex flex-col gap-7 bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10"
          >
            <InputField
              htmlFor="email"
              labelName="Email Address"
              name="email"
              key={'email'}
              type="email"
              handelChange={handelChange}
              value={email}
            />
            <InputField
              htmlFor="password"
              labelName="Password"
              name="password"
              key={'password'}
              type="password"
              handelChange={handelChange}
              value={password}
            />

            <button
              onClick={handelSubmit}
              className="flex w-full items-center justify-center rounded-md border border-black px-6 py-2 "
            >
              Log in
            </button>
            <NavLink
              to={'/'}
              className={'text-end font-semibold text-[#D4AF37]'}
            >
              Forget Password
            </NavLink>
          </form>
        </div>
      </div>
    </ContentLayout>
  )
}

export default Login
